import { useCallback } from 'react'

// fe-core's GlobalHeader and PrimaryHeader hardcode href="/" on the logo with
// no onLogoClick prop. We use event delegation on the outer wrapper div and
// closest() to detect logo clicks — the logo is the only href="/" anchor in
// either header.
export function useLogoClickHandler(isAlpAsFrontpage: boolean) {
  return useCallback(
    (e: React.MouseEvent<HTMLDivElement>) => {
      if (!isAlpAsFrontpage) return
      if ((e.target as HTMLElement).closest('a[href="/"]')) {
        document.cookie =
          'bstock_hp_intent=1; path=/; max-age=600; Secure; SameSite=Strict'
      }
    },
    [isAlpAsFrontpage]
  )
}
